import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { bootstrap } from './config/bootstrap';
import { renderConfigError } from './config/error-screen';

let reactRoot: ReactDOM.Root | undefined;

async function start(): Promise<void> {
  try {
    await bootstrap(); // config frozen before ANY module in App's graph evaluates
    const { default: App } = await import('./App');
    if (!reactRoot) {
      reactRoot = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    }
    reactRoot.render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
    reportWebVitals();
  } catch (err) {
    // If React had already mounted (a render-phase crash), unmount it before the
    // plain-DOM error screen takes over #root — avoids a second createRoot() on
    // retry and a stale fiber tree over manually-cleared DOM.
    if (reactRoot) {
      try {
        reactRoot.unmount();
      } catch {
        /* ignore */
      }
      reactRoot = undefined;
    }
    renderConfigError(err, start);
  }
}

void start();
